"use client"

import {
    Box,
    Button,
    Container,
    Grid,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Chip,
    IconButton,
    TableRow,
    TableCell,
    TableBody,
    Table,
} from "@mui/material"
import { Visibility, Code, Share, ContentCopy, Instagram, Facebook } from "@mui/icons-material"
import { useState } from "react"
import { Images } from "../../../assests"
import { useLocation, useNavigate } from "react-router-dom"

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // important
import { currencyType } from "../../../utils"


const dummyMerchants = [
    {
        id: 1,
        name: "UrbanStitch",
        description: "UrbanStitch is your go-to destination...",
        state: "California",
        city: "Los Angeles",
        standard: {
            oneSide: "$20",
            doubleSide: "$40",
            additional: "$20",
        },
        premium: {
            oneSide: "$50",
            doubleSide: "$80",
            additional: "$20",
        },
    },

]
const platformIcons = {
    facebook: <FacebookIcon sx={{ color: "#0BD1D1", fontSize: '32px' }} />,
    instagram: <InstagramIcon sx={{ color: "#0BD1D1", fontSize: '32px' }} />,
    twitter: <TwitterIcon sx={{ color: "#0BD1D1", fontSize: '32px' }} />,
    linkedin: <LinkedInIcon sx={{ color: "#0BD1D1", fontSize: '32px' }} />,
};
const dummyVendors = [
    {
        id: 1,
        name: "PremiumFit",
        description:
            "UrbanStitch is your go-to destination for stylish, high-quality t-shirts crafted with comfort and individuality in mind",
        state: "California",
        city: "Los Angeles",
        images: [
            "/standard-shirt1.png",
            "/standard-shirt2.png",
            "/premium-shirt1.png",
            "/premium-shirt2.png",
            "/premium-shirt3.png",
        ],
        standardPrice: {
            oneSide: "$20",
            doubleSide: "$40",
            additional: "$20",
            standardTag: "$25",
        },
        premiumPrice: {
            oneSide: "$50",
            doubleSide: "$80",
            additional: "$20",
            premiumTag: "$50",
        },
    },
]
const fabricOptions = [
    "Polyester",
    "Cotton",
    "Linen",
    "Organic Cotton",
    "Combed Cotton",
    "Modal",
    "Hemp",
    "Lycra",
    "Ringspun Cotton",
    "Nylon",
    "Rayon/Bamboo Viscose",
    "Poly",
    "Flannel",
    "Pima Cotton",
    "Bulk Cotton",
    "Spandex",
    "Sustainability",
    "Fleece Fabric",
]

const MerchantDetail = () => {
    const [selectedFabrics, setSelectedFabrics] = useState([])
    const navigate = useNavigate()
    const [vendors] = useState(dummyVendors)
    const { state } = useLocation()
    const handleFabricChange = (fabric) => {
        setSelectedFabrics((prev) => (prev.includes(fabric) ? prev.filter((f) => f !== fabric) : [...prev, fabric]))
    }
    console.log(state, 'statestate');
    const images = state?.merchant?.products?.[0]?.sample_images || [];
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>
            <Box
                sx={{
                    backgroundImage: `url("${Images.contactBg}")`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "300px", // Adjust height as needed
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                    <Typography
                        variant="h3"
                        className="banner-text heading-font"
                        sx={{
                            fontSize: "35px",
                            textAlign: "center",
                            fontFamily: "Noto Sans, sans-serif",
                            color: "white",
                            fontWeight: "bold",
                        }}
                    >
                        Merchant Details
                    </Typography>
                </Box>
            </Box>
            <Container maxWidth={"lg"} sx={{ my: 4 }}>

                <Grid container spacing={3}>

                    <Grid item xs={12} md={12}>

                        <Grid container spacing={3}>

                            <Grid item xs={12} >
                                <Card
                                    sx={{
                                        bgcolor: "#192133",
                                        color: "white",
                                        borderRadius: '14px',
                                        p: 3,
                                        boxShadow: 3,
                                    }}
                                >

                                    <Grid container spacing={5}>
                                        {/* LEFT SIDE (Info + Prices + Buttons) */}

                                        <Grid item xs={12} md={5.5} >
                                            {/* Description */}
                                            <Typography variant="h4" className="heading-font" sx={{ mb: 2, fontFamily: "Maven Pro, sans-serif", fontWeight: 'bold' }}>
                                                {state?.merchant?.name}
                                            </Typography>

                                            <Grid
                                                container
                                                spacing={0}
                                                sx={{
                                                    mb: 3,
                                                    mt: 2,
                                                    borderBottom: "1px solid rgba(255,255,255,0.2)", // full box border



                                                }}
                                            >
                                                <Grid
                                                    item
                                                    xs={5}
                                                    sx={{
                                                        borderRight: "1px solid rgba(255,255,255,0.2)",
                                                        p: 2,
                                                        mb: 1,
                                                        pb: 0,
                                                    }}
                                                >
                                                    <Typography variant="body2" sx={{ fontFamily: "Maven Pro, sans-serif " }}>
                                                        <strong>State</strong>
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif " }}>
                                                        {state?.merchant?.state}
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={7} sx={{ p: 2, pb: 0, pl: 6 }}>
                                                    <Typography variant="body2" sx={{ fontFamily: "Maven Pro, sans-serif " }}>
                                                        <strong>City</strong>
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif " }}>
                                                        {state?.merchant?.city}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid
                                                container
                                                spacing={0}
                                                sx={{
                                                    mb: 3,
                                                    mt: 2,
                                                    borderBottom: "1px solid rgba(255,255,255,0.2)", // full box border



                                                }}
                                            >
                                                <Grid
                                                    item
                                                    xs={5}
                                                    sx={{
                                                        borderRight: "1px solid rgba(255,255,255,0.2)",
                                                        p: 2,
                                                        mb: 1,
                                                        pb: 0
                                                    }}
                                                >
                                                    <Typography variant="body2" sx={{ fontFamily: "Maven Pro, sans-serif " }}>
                                                        <strong>Email</strong>
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif ",wordBreak:'break-word' }}>
                                                        {state?.merchant?.email}
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={7} sx={{ p: 2, pb: 0, pl: 6 }}>
                                                    <Typography variant="body2" sx={{ fontFamily: "Maven Pro, sans-serif " }}>
                                                        <strong>Phone Number</strong>
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif " }}>
                                                        {state?.merchant?.phone}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid
                                                container
                                                spacing={0}
                                                sx={{
                                                    mb: 3,
                                                    mt: 2,
                                                    borderBottom: "1px solid rgba(255,255,255,0.2)", // full box border
                                                }}
                                            >
                                                {/* Standard Fabrics */}
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sx={{
                                                        borderRight: "1px solid rgba(255,255,255,0.2)",
                                                        p: 2,
                                                        mb: 1,
                                                        pb: 0,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        <strong>Standard Fabrics</strong>
                                                    </Typography>

                                                    <Typography
                                                        variant="body2"
                                                        sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        {state?.merchant?.products[0]?.fabrics?.length > 0 &&
                                                            state.merchant.products[0].fabrics
                                                                .map((fabric) => fabric?.name ?? fabric)
                                                                .join(", ")}
                                                    </Typography>
                                                </Grid>

                                                {/* Premium Fabrics */}
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sx={{
                                                        p: 2,
                                                        mb: 1,
                                                        pb: 0,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        <strong>Premium Fabrics</strong>
                                                    </Typography>

                                                    <Typography
                                                        variant="body2"
                                                        sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        {state?.merchant?.products[0]?.premium_fabrics?.length > 0 &&
                                                            state.merchant.products[0].fabrics
                                                                .map((fabric) => fabric?.name ?? fabric)
                                                                .join(", ")}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
 <Grid
                                                container
                                                spacing={0}
                                                sx={{
                                                    mb: 3,
                                                    mt: 2,
                                                    borderBottom: "1px solid rgba(255,255,255,0.2)", // full box border
                                                }}
                                            >
                                                {/* Standard Fabrics */}
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sx={{
                                                        
                                                        p: 2,
                                                        mb: 1,
                                                        pb: 0,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ fontFamily: "Maven Pro, sans-serif " }}
                                                    >
                                                        <strong>Printing Methods</strong>
                                                    </Typography>

                                                    <Typography
                                                        variant="body2"
                                                        sx={{ mt: 1, fontFamily: "Maven Pro, sans-serif " }}
                                                >
                                                        {state?.merchant?.printing_methods?.length > 0 &&
                                                            state.merchant.printing_methods
                                                                .map((method) => method?.name ?? method)
                                                                .join(", ")}
                                                    </Typography>
                                                </Grid>

                                            </Grid>
                                            {/* Standard Prices */}
                                            <Box sx={{ mb: 3, borderBottom: "1px solid rgba(255,255,255,0.2)", pb: "10px" }}>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif ", m: 2, mb: 0 }}
                                                >
                                                    <strong>Standard Shipping Price</strong>
                                                </Typography>
                                                <Grid container m={2} mb={0}>
                                                    <Grid
                                                        item
                                                        xs={4}
                                                        sx={{
                                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                                            pr: 2,
                                                            fontFamily: "Maven Pro, sans-serif ",
                                                        }}
                                                    >
                                                        <Typography variant="caption">Days</Typography>
                                                        <Typography variant="body2" mt={1.5}>
                                                            {state?.merchant?.shipping?.standard?.days}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={4}
                                                        sx={{
                                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                                            px: 2,
                                                        }}
                                                    >
                                                        <Typography variant="caption">In City</Typography>
                                                        <Typography variant="body2" mt={1.5}>
                                                            {currencyType[process.env.REACT_APP_CURRENCY]?.code} {state?.merchant?.shipping?.standard?.instate_price}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={4}
                                                        sx={{
                                                            pl: 2,
                                                        }}
                                                    >
                                                        <Typography variant="caption">Out City</Typography>
                                                        <Typography variant="body2" mt={1.5}>
                                                            {currencyType[process.env.REACT_APP_CURRENCY]?.code} {state?.merchant?.shipping?.standard?.outstate_price}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Box>

                                            {/* Premium Prices */}
                                            <Box sx={{ mb: 3, borderBottom: "1px solid rgba(255,255,255,0.2)", pb: "10px" }}>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif ", m: 2, mb: 0 }}
                                                >
                                                    <strong>Premium  Shipping Price</strong>
                                                </Typography>
                                                <Grid container m={2} mb={0}>
                                                    <Grid
                                                        item
                                                        xs={4}
                                                        sx={{
                                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                                            pr: 2,
                                                        }}
                                                    >
                                                        <Typography variant="caption">Days</Typography>
                                                        <Typography variant="body2" mt={1.5}>
                                                            {state?.merchant?.shipping?.premium?.days}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={4}
                                                        sx={{
                                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                                            px: 2,
                                                        }}
                                                    >
                                                        <Typography variant="caption">In City</Typography>
                                                        <Typography variant="body2" mt={1.5}>
                                                            {currencyType[process.env.REACT_APP_CURRENCY]?.code} {state?.merchant?.shipping?.premium?.instate_price}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={4}
                                                        sx={{
                                                            pl: 2,
                                                        }}
                                                    >
                                                        <Typography variant="caption">Out City</Typography>
                                                        <Typography variant="body2" mt={1.5}>
                                                            {currencyType[process.env.REACT_APP_CURRENCY]?.code} {state?.merchant?.shipping?.premium?.outstate_price}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            <Box sx={{ mb: 3, pb: "10px" }}>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif ", m: 2, mb: 0 }}
                                                >
                                                    <strong>Express  Shipping Price</strong>
                                                </Typography>
                                                <Grid container m={2} mb={0}>
                                                    <Grid
                                                        item
                                                        xs={4}
                                                        sx={{
                                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                                            pr: 2,
                                                        }}
                                                    >
                                                        <Typography variant="caption">Days</Typography>
                                                        <Typography variant="body2" mt={1.5}>
                                                            {state?.merchant?.shipping?.express?.days}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={4}
                                                        sx={{
                                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                                            px: 2,
                                                        }}
                                                    >
                                                        <Typography variant="caption">In City</Typography>
                                                        <Typography variant="body2" mt={1.5}>
                                                            {currencyType[process.env.REACT_APP_CURRENCY]?.code} {state?.merchant?.shipping?.express?.instate_price}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={4}
                                                        sx={{
                                                            pl: 2,
                                                        }}
                                                    >
                                                        <Typography variant="caption">Out City</Typography>
                                                        <Typography variant="body2" mt={1.5}>
                                                            {currencyType[process.env.REACT_APP_CURRENCY]?.code} {state?.merchant?.shipping?.express?.outstate_price}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Box>

                                            {/* Buttons */}
                                            {/* <Box >

                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={() => {
                                                        localStorage.setItem("merchant", JSON.stringify(state?.merchant));
                                                        navigate("/cart", {
                                                            state: { merchant: state?.merchant }, // ✅ provide key properly
                                                        })
                                                    }
                                                    }

                                                    sx={{
                                                        bgcolor: "#0BD1D1",
                                                        border: "1px solid #0BD1D1",   // ✅ correct way
                                                        color: "#101A33",
                                                        fontWeight: 700,
                                                        width: '60%',
                                                        "&:hover": {
                                                            bgcolor: "#0BD1D1", // softer hover bg
                                                            border: "1px solid #0BD1D1",        // change border color on hover
                                                            color: "#101A33",                   // optional: change text color too
                                                        },
                                                        flex: 1,
                                                        fontFamily: "Maven Pro, sans-serif",
                                                        textTransform: "capitalize",
                                                        borderRadius: "12px",  // ✅ add rounded corners if you want
                                                        padding: "6px 16px",  // ✅ better button spacing
                                                    }}
                                                >
                                                    Proceed  Order With This Merchant
                                                </Button>
                                            </Box> */}
                                        </Grid>
                                        <Grid
                                            item
                                            md={1}
                                            sx={{
                                                display: { xs: "none", md: "flex" }, // hide on mobile
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    borderRight: "1px solid rgba(255,255,255,0.2)",
                                                    height: "100%",
                                                }}
                                            />
                                        </Grid>
                                        {/* RIGHT SIDE (Images) */}
                                        <Grid item xs={12} md={5.5} mt={2}>
                                            <Grid container spacing={2}>


                                                {/* RIGHT SIDE (Main + 2 smaller images) */}
                                                <Grid item xs={12}>
                                                    {/* Main Image */}
                                                    <Box sx={{ mb: 2 }}>
                                                        <CardMedia
                                                            component="img"
                                                            height="530"
                                                            image={images[0]}
                                                            alt="Main"
                                                            sx={{ borderRadius: "8px", cursor: "pointer" }}
                                                            onClick={() => {
                                                                setPhotoIndex(0);
                                                                setIsOpen(true);
                                                            }}
                                                        />
                                                    </Box>

                                                    {/* Additional Images */}
                                                    <Grid container spacing={2}>
                                                        {images.slice(1).map((img, index) => (
                                                            <Grid item xs={4} key={index}>
                                                                <CardMedia
                                                                    component="img"
                                                                    height="130"
                                                                    image={img}
                                                                    alt={`extra-${index + 1}`}
                                                                    sx={{ borderRadius: "8px", cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        setPhotoIndex(index + 1); // +1 because we sliced
                                                                        setIsOpen(true);
                                                                    }}
                                                                />
                                                            </Grid>
                                                        ))}
                                                    </Grid>

                                                    {/* Lightbox */}
                                                    {isOpen && (
                                                        <Lightbox
                                                            mainSrc={images[photoIndex]}
                                                            nextSrc={images[(photoIndex + 1) % images.length]}
                                                            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                                                            onCloseRequest={() => setIsOpen(false)}
                                                            onMovePrevRequest={() =>
                                                                setPhotoIndex((photoIndex + images.length - 1) % images.length)
                                                            }
                                                            onMoveNextRequest={() =>
                                                                setPhotoIndex((photoIndex + 1) % images.length)
                                                            }
                                                        />
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Card>
                            </Grid>

                        </Grid>
                        <Container maxWidth="lg" sx={{ mt: 6, mb: 6 }}>
                            <Grid container spacing={2}>
                                {/* LEFT SIDE */}
                                <Grid item xs={12} md={12}>
                                    {/* Description */}
                                    <Typography
                                        variant="h5"
                                        className="banner-text heading-font"
                                        sx={{ mb: 2, fontWeight: "bold", color: "white", fontFamily: "Maven Pro, sans-serif" }}
                                    >
                                        Description
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 3, color: "rgba(255,255,255,0.8)" }}>
                                        {state?.merchant?.business_description}
                                    </Typography>
                                    <Typography
                                        variant="h5"
                                        className="banner-text heading-font"
                                        sx={{ mb: 2, fontWeight: "bold", color: "white", fontFamily: "Maven Pro, sans-serif" }}
                                    >
                                        Size Chart
                                    </Typography>
                                    {/* Size Chart */}
                                    <Box
                                        sx={{
                                            border: "1px solid #0bd1d1",
                                            borderRadius: "12px",
                                            overflow: "hidden", // ✅ ensures rounded corners are applied
                                            mb: 3,
                                            p: 1.5
                                        }}
                                    >
                                        <table style={{ width: "100%", borderCollapse: "collapse", color: "white", }} >
                                            <thead>
                                                <tr > <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Size</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Chest</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Length</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Shoulder</th> </tr> </thead>

                                            <tbody>
                                                {state?.merchant?.products[0]?.size_chart?.length > 0 &&
                                                    state?.merchant?.products[0]?.size_chart?.map((row, i) => (
                                                        <tr
                                                            key={i}
                                                            style={{ borderTop: "1px solid rgba(255,255,255,0.2)" }}
                                                        >
                                                            {/* Map over the values of each object */}
                                                            {Object.values(row).map((col, j) => (
                                                                <td key={j} style={{ padding: "10px", fontSize: "14px" }}>
                                                                    {col}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </Box>


                                    {/* Social Media */}
                                    <Typography
                                        variant="h6"
                                        className="banner-text heading-font"
                                        sx={{ mb: 0, fontWeight: "bold", color: "white", fontFamily: "Maven Pro, sans-serif" }}
                                    >
                                        Social Media Links
                                    </Typography>

                                    <Grid container spacing={2} sx={{ mt: 0 }}>
                                        {state?.merchant?.social_medias?.map((link, index) => (
                                            <Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={4}
                                                key={index}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 2,
                                                    p: 2,
                                                }}
                                            >
                                                {/* Icon */}
                                                <Box
                                                    sx={{
                                                        fontSize: "22px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    {platformIcons[link?.type?.toLowerCase?.()]}
                                                </Box>


                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>



                                {/* RIGHT SIDE */}

                            </Grid>
                        </Container>

                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default MerchantDetail
